import React, { useState, useEffect } from 'react';
import '../App.css';

function ServerSettings({ isOpen, onClose }) {
    const url = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    const loggedInUser = localStorage.getItem('Login'); 
    const SUPER_ADMIN = "admin@deadergate"; 
    
    // Estados Usuarios
    const [usersRows, setUsersRows] = useState([]);
    const [newUser, setNewUser] = useState({ email: '', password: '', role: 'user' }); 
    
    // Estados Hardware
    const [noAuth, setNoAuth] = useState([]);
    const [manualIdent, setManualIdent] = useState("");

    const [statusMsg, setStatusMsg] = useState({ text: "", type: "" });

    const showMessage = (text, type = "success") => {
        setStatusMsg({ text, type });
        setTimeout(() => setStatusMsg({ text: "", type: "" }), 4000);
    };

    const formatTacticalDate = (isoString) => {
        if (!isoString || isoString === '---') return "Nunca";
        const date = new Date(isoString);
        if (isNaN(date)) return "---";
        const day = (0 + date.getDate().toString()).slice(-2);
        const month = (0 + (date.getMonth() + 1).toString()).slice(-2);
        const year = date.getFullYear().toString().slice(-2);
        const hours = (0 + date.getHours().toString()).slice(-2);
        const minutes = (0 + date.getMinutes().toString()).slice(-2);
        return `${day}/${month}/${year} [${hours}:${minutes}]`;
    };

    // --- FETCH COMBINADO (Usuarios + Hardware) ---
    const fetchAdminData = async () => {
        if (!isOpen) return;
        try {
            let options = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'x-access-token': token }
            };
            
            // 1. Cargar Usuarios
            let resUsers = await fetch(url + '/users', options);
            if (resUsers.ok) setUsersRows(await resUsers.json());

            // 2. Cargar Hardware Pendiente
            let resNoAuth = await fetch(url + '/noAuth', options);
            if (resNoAuth.ok) setNoAuth(await resNoAuth.json());

        } catch (err) {
            console.error("Error obteniendo datos de administración:", err);
        }
    };

    useEffect(() => {
        fetchAdminData();
        const timer = setInterval(() => { if (isOpen) fetchAdminData(); }, 15000); // Refresco cada 15s para no saturar
        return () => clearInterval(timer);
    }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps


    // ===============================================
    // ACCIONES DE USUARIO
    // ===============================================
    const createUser = async (e) => {
        e.preventDefault();
        if (!newUser.email || !newUser.password) return showMessage("⚠️ Rellena todos los campos", "error");

        try {
            let options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-access-token': token },
                body: JSON.stringify({ email: newUser.email, password: newUser.password, role: newUser.role })
            };
            let response = await fetch(url + '/registerUser', options);
            
            if (response.ok) {
                showMessage(`✅ ${newUser.role === 'admin' ? 'Admin' : 'Operator'} created.`);
                setNewUser({ email: '', password: '', role: 'user' }); 
                fetchAdminData();
            } else {
                showMessage(`❌ Error creating user.`, "error");
            }
        } catch (err) { console.error(err); }
    };

    const deleteUser = async (id, email) => {
        if (email.toLowerCase() === SUPER_ADMIN) return showMessage("⚠️ The supreme user is indestructible.", "error");
        if (email === loggedInUser) return showMessage("⚠️ Cannot delete yourself.", "error");

        if(window.confirm(`¿Delete user: ${email}?`)) {
            try {
                let options = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'x-access-token': token },
                    body: JSON.stringify({ idUser: id })
                };
                let response = await fetch(url + '/deleteUser', options);
                if (response.ok) {
                    showMessage(`🗑️ Deleted user: ${email}.`);
                    fetchAdminData();
                }
            } catch (err) { console.error(err); }
        }
    };

    // ===============================================
    // ACCIONES DE HARDWARE
    // ===============================================
    const handleManualRegister = async (e) => {
        e.preventDefault();
        if (!manualIdent.trim()) return;
        await sendRegisterRequest(manualIdent);
        setManualIdent(""); 
    };

    const sendRegisterRequest = async (ident) => {
        try {
            let options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-access-token': token },
                body: JSON.stringify({ email: loggedInUser, ident: ident })
            };
            let response = await fetch(url + '/register', options);
            if (response.ok) {
                showMessage(`✅ Device ${ident} registered successfully.`);
                fetchAdminData();
            } else {
                showMessage(`❌ Error registering device ${ident}.`, "error");
            }
        } catch (err) { console.error(err); }
    };

    const denyDetector = async (ident) => {
        try {
            let options = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-access-token': token },
                body: JSON.stringify({ ident: ident, user: loggedInUser, action: "deny" })
            };
            let response = await fetch(url + '/noAuth', options);
            if (response.ok) {
                showMessage(`🗑️ Hardware intrusion revoked.`);
                fetchAdminData();
            }
        } catch (err) { console.error(err); }
    };


    return (
        <div className={`alerts-page-wrapper ${isOpen ? 'open' : ''}`}>
            <div className="alerts-header">
                <h1 className="alerts-title" style={{fontSize: '18px'}}>
                    <i className="fa-solid fa-gear" style={{marginRight: '10px'}}></i> SERVER CONFIG
                </h1>
                <button className="btn-close-alerts" onClick={onClose}>
                    <i className="fa-solid fa-xmark"></i>
                </button>
            </div>

            {statusMsg.text && (
                <div style={{ padding: '10px', borderRadius: '8px', marginBottom: '15px', backgroundColor: statusMsg.type === 'error' ? 'rgba(255,0,0,0.2)' : 'rgba(0,255,0,0.2)', color: statusMsg.type === 'error' ? '#ff4444' : '#00ff00', border: `1px solid ${statusMsg.type === 'error' ? '#ff4444' : '#00ff00'}`, fontSize: '13px', textAlign: 'center', fontWeight: 'bold' }}>
                    {statusMsg.text}
                </div>
            )}

            <div className="logs-grid">
                
                {/* =========================================
                    BLOQUE 1: HARDWARE PROVISIONING
                    ========================================= */}
                <div style={{ marginBottom: '20px' }}>
                    <div className="register-section-title" style={{ marginTop: '0' }}>REGISTER DEVICES</div>
                    
                    {/* Alertas de hardware pendiente (Siempre visible) */}
                    {noAuth.length === 0 ? (
                        <div style={{ textAlign: 'center', color: '#666', fontSize: '12px', padding: '10px 0', marginBottom: '15px', fontStyle: 'italic', border: '1px dashed #333', borderRadius: '8px' }}>
                            <span style={{color: '#00ff00'}}>🟢</span> No new devices to register.
                        </div>
                    ) : (
                        <div style={{ marginBottom: '15px', padding: '10px', border: '1px dashed #ff9800', borderRadius: '8px', background: 'rgba(255, 152, 0, 0.05)' }}>
                            <div style={{ color: '#ff9800', fontSize: '12px', fontWeight: 'bold', marginBottom: '10px' }}>
                                ⚠️ PENDING AUTH DEVICES
                            </div>
                            {noAuth.map((item, index) => (
                                <div key={index} className="pending-card" style={{ marginBottom: '10px' }}>
                                    <div className="pending-info">
                                        <span className="pending-id">{item.ident}</span>
                                        <span className="pending-date">Intento: {formatTacticalDate(item.lastAttempt)}</span>
                                    </div>
                                    <div className="pending-actions">
                                        <button className="btn-action-icon accept" title="Authorize" onClick={() => sendRegisterRequest(item.ident)}>
                                            <i className="fa-solid fa-check"></i>
                                        </button>
                                        <button className="btn-action-icon deny" title="Block" onClick={() => denyDetector(item.ident)}>
                                            <i className="fa-solid fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Registro manual */}
                    <form className="tactical-input-group" onSubmit={handleManualRegister} style={{ marginBottom: '0' }}>
                        <input 
                            type="text" 
                            placeholder="Add Device SN" 
                            value={manualIdent}
                            onChange={(e) => setManualIdent(e.target.value)}
                        />
                        <button type="submit" className="btn-register">REGISTER</button>
                    </form>
                </div>


                {/* =========================================
                    BLOQUE 2: IDENTITY & ACCESS (USERS)
                    ========================================= */}
                <div style={{ marginTop: '10px', borderTop: '1px dashed #333', paddingTop: '15px' }}>
                    <div className="register-section-title" style={{ marginTop: '0' }}>USER MANAGEMENT</div>
                    
                    {/* Lista de Usuarios */}
                    {usersRows.length === 0 ? (
                        <div style={{ textAlign: 'center', color: '#666', marginTop: '10px', fontSize: '14px' }}>Loading users...</div>
                    ) : (
                        <div style={{ maxHeight: '250px', overflowY: 'auto', marginBottom: '15px', paddingRight: '5px' }}>
                            {usersRows.map((user, index) => {
                                const isSuperAdmin = user.email.toLowerCase() === SUPER_ADMIN;
                                const displayRole = isSuperAdmin ? 'admin' : (user.role || 'user');

                                return (
                                    <div key={index} className="pending-card" style={{ borderLeftColor: displayRole === 'admin' ? '#f44336' : '#00bcd4', marginBottom: '10px', padding: '10px' }}>
                                        <div className="pending-info">
                                            <span className="pending-id" style={{ fontSize: '13px' }}>
                                                <i className="fa-solid fa-user-astronaut" style={{marginRight: '8px', color: displayRole === 'admin' ? '#f44336' : '#00bcd4'}}></i>
                                                {user.email}
                                                <span className={`role-badge ${displayRole}`}>{displayRole.toUpperCase()}</span>
                                                {isSuperAdmin && <span title="Indestructible" style={{marginLeft:'5px'}}>🛡️</span>}
                                            </span>
                                            <span className="pending-date" style={{marginTop: '2px'}}>
                                                Last Login: {formatTacticalDate(user.lastLogin)}
                                            </span>
                                        </div>
                                        <div className="pending-actions">
                                            <button 
                                                className={`btn-action-icon deny ${isSuperAdmin ? 'indestructible-user' : ''}`} 
                                                title={isSuperAdmin ? "Inmune" : "Revocar"}
                                                onClick={() => deleteUser(user._id, user.email)}
                                                disabled={isSuperAdmin}
                                                style={{ width: '30px', height: '30px' }}
                                            >
                                                <i className="fa-solid fa-user-xmark" style={{fontSize: '12px'}}></i>
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Crear Nuevo Usuario */}
                    <form className="tactical-input-group" style={{ flexDirection: 'column', gap: '10px', marginBottom: '0' }} onSubmit={createUser}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <input 
                                type="email" 
                                placeholder="New email..." 
                                value={newUser.email}
                                onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                                required
                            />
                            <select 
                                className="tactical-input" 
                                value={newUser.role} 
                                onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                                style={{ width: '100px', padding: '10px' }}
                            >
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <input 
                                type="password" 
                                placeholder="Password..." 
                                value={newUser.password}
                                onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                                required
                                style={{ flex: 1 }}
                            />
                            <button type="submit" className="btn-register" style={{ width: '100px' }}>CREATE</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default ServerSettings;